import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchBlogPost } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { fetchBlogPost(slug).then(setP).catch(() => setP(null)); window.scrollTo(0, 0); }, [slug]);
  if (!p) return <div className="pt-32 text-center min-h-screen">Loading...</div>;
  return (
    <div className="pt-28 pb-24 bg-brand-ivory">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10">
        <Link to="/blog" className="text-sm text-brand-navy hover:text-brand-gold inline-flex items-center gap-2 mb-6"><ArrowLeft size={14} /> Back to Journal</Link>
        <div className="divider-gold">{p.author}</div>
        <h1 className="mt-4 font-serif text-4xl lg:text-5xl text-brand-navy leading-tight">{p.title}</h1>
        <div className="mt-6 aspect-[16/9] overflow-hidden"><img src={p.cover} alt={p.title} className="w-full h-full object-cover" /></div>
        <p className="mt-8 text-lg text-brand-charcoal/80 italic">{p.excerpt}</p>
        <div className="mt-6 text-brand-charcoal leading-relaxed whitespace-pre-line">{p.content}</div>
        <div className="mt-8 flex gap-2 flex-wrap">
          {(p.tags || []).map(t => <span key={t} className="border border-brand-gold/40 text-xs px-3 py-1 text-brand-navy uppercase tracking-widest">{t}</span>)}
        </div>
      </div>
    </div>
  );
}
